/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as AcceptInviteRouteImport } from './routes/accept-invite'
import { Route as OrganizationsRouteRouteImport } from './routes/organizations/route'
import { Route as OneauthRouteRouteImport } from './routes/oneauth/route'
import { Route as OnboardingRouteRouteImport } from './routes/onboarding/route'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as AuthRouteRouteImport } from './routes/_auth/route'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as ScheduleTokenRouteImport } from './routes/schedule.$token'
import { Route as PortfolioUserIdRouteImport } from './routes/portfolio.$userId'
import { Route as AuthSignInRouteImport } from './routes/_auth/sign-in'
import { Route as AuthLoginRouteImport } from './routes/_auth/login'
import { Route as OnboardingProfileRouteRouteImport } from './routes/onboarding/profile/route'
import { Route as OnboardingRouteWapperRouteRouteImport } from './routes/onboarding/_route-wapper/route'
import { Route as OauthCallbacksCallbackRouteRouteImport } from './routes/_oauth-callbacks/callback/route'
import { Route as AuthenticatedSettingsManageTeamRouteImport } from './routes/_authenticated/settings/manage-team'
import { Route as AuthAuthSetPasswordRouteImport } from './routes/_auth/auth/set-password'
import { Route as AuthenticatedJobsJobIdRouteRouteImport } from './routes/_authenticated/jobs/$jobId/route'
import { Route as AuthAuthTalentScoutRouteRouteImport } from './routes/_auth/auth/talent-scout/route'
import { Route as AuthAuthCallbackIndexRouteImport } from './routes/_auth/auth/callback/index'
import { Route as AuthenticatedJobsJobIdConfigureRouteRouteImport } from './routes/_authenticated/jobs/$jobId/configure/route'

const OrganizationsIndexLazyRouteImport = createFileRoute('/organizations/')()
const OrgNotFoundLazyRouteImport = createFileRoute('/org/not-found')()
const OneauthConnectLazyRouteImport = createFileRoute('/oneauth/connect')()
const OneauthTokenLazyRouteImport = createFileRoute('/oneauth/$token')()
const AuthenticatedApplicationsLazyRouteImport = createFileRoute(
  '/_authenticated/applications',
)()
const AuthForgotPasswordLazyRouteImport = createFileRoute(
  '/_auth/forgot-password',
)()
const errors503LazyRouteImport = createFileRoute('/(errors)/503')()
const errors500LazyRouteImport = createFileRoute('/(errors)/500')()
const errors404LazyRouteImport = createFileRoute('/(errors)/404')()
const errors403LazyRouteImport = createFileRoute('/(errors)/403')()
const errors401LazyRouteImport = createFileRoute('/(errors)/401')()
const AuthenticatedSettingsRouteLazyRouteImport = createFileRoute(
  '/_authenticated/settings',
)()
const OnboardingProfileIndexLazyRouteImport = createFileRoute(
  '/onboarding/profile/',
)()
const AuthenticatedSupportIndexLazyRouteImport = createFileRoute(
  '/_authenticated/support/',
)()
const AuthenticatedSettingsIndexLazyRouteImport = createFileRoute(
  '/_authenticated/settings/',
)()
const AuthenticatedSalaryInsightsIndexLazyRouteImport = createFileRoute(
  '/_authenticated/salary-insights/',
)()
const AuthenticatedRoadmapsIndexLazyRouteImport = createFileRoute(
  '/_authenticated/roadmaps/',
)()
const AuthenticatedResumeBuilderIndexLazyRouteImport = createFileRoute(
  '/_authenticated/resume-builder/',
)()
const AuthenticatedProfileIndexLazyRouteImport = createFileRoute(
  '/_authenticated/profile/',
)()
const AuthenticatedPracticeIndexLazyRouteImport = createFileRoute(
  '/_authenticated/practice/',
)()
const AuthenticatedLearningHubIndexLazyRouteImport = createFileRoute(
  '/_authenticated/learning-hub/',
)()
const AuthenticatedLeaderboardsIndexLazyRouteImport = createFileRoute(
  '/_authenticated/leaderboards/',
)()
const AuthenticatedJobsIndexLazyRouteImport = createFileRoute(
  '/_authenticated/jobs/',
)()
const AuthenticatedInterviewsIndexLazyRouteImport = createFileRoute(
  '/_authenticated/interviews/',
)()
const AuthenticatedHelpCenterIndexLazyRouteImport = createFileRoute(
  '/_authenticated/help-center/',
)()
const AuthenticatedDiscussionsIndexLazyRouteImport = createFileRoute(
  '/_authenticated/discussions/',
)()
const AuthenticatedAtsCheckerIndexLazyRouteImport = createFileRoute(
  '/_authenticated/ats-checker/',
)()
const AuthenticatedAssessmentsIndexLazyRouteImport = createFileRoute(
  '/_authenticated/assessments/',
)()
const AuthSignUpIndexLazyRouteImport = createFileRoute('/_auth/sign-up/')()
const ReportsCandidateReportRidLazyRouteImport = createFileRoute(
  '/reports/candidate-report/$rid',
)()
const OnboardingRouteWapperSuccessLazyRouteImport = createFileRoute(
  '/onboarding/_route-wapper/success',
)()
const OnboardingRouteWapperCreateOrgLazyRouteImport = createFileRoute(
  '/onboarding/_route-wapper/create-org',
)()
const OauthCallbacksCallbackZoomOauthLazyRouteImport = createFileRoute(
  '/_oauth-callbacks/callback/zoom-oauth',
)()
const OauthCallbacksCallbackMicrosoftOauthLazyRouteImport = createFileRoute(
  '/_oauth-callbacks/callback/microsoft-oauth',
)()
const OauthCallbacksCallbackGoogleOauthLazyRouteImport = createFileRoute(
  '/_oauth-callbacks/callback/google-oauth',
)()
const AuthenticatedSettingsPipelinesLazyRouteImport = createFileRoute(
  '/_authenticated/settings/pipelines',
)()
const AuthenticatedSettingsCommunicationsLazyRouteImport = createFileRoute(
  '/_authenticated/settings/communications',
)()
const AuthenticatedSettingsCareerPagesLazyRouteImport = createFileRoute(
  '/_authenticated/settings/career-pages',
)()
const AuthenticatedSettingsBillingLazyRouteImport = createFileRoute(
  '/_authenticated/settings/billing',
)()
const AuthenticatedSettingsActivityLogLazyRouteImport = createFileRoute(
  '/_authenticated/settings/activity-log',
)()
const AuthenticatedJobsCreateLazyRouteImport = createFileRoute(
  '/_authenticated/jobs/create',
)()
const AuthenticatedAssessmentsAssessmentIdLazyRouteImport = createFileRoute(
  '/_authenticated/assessments/$assessmentId',
)()
const AuthSignUpEmailSentLazyRouteImport = createFileRoute(
  '/_auth/sign-up/email-sent',
)()
const AuthenticatedSettingsOperationLogIndexLazyRouteImport = createFileRoute(
  '/_authenticated/settings/operation-log/',
)()
const AuthenticatedOnboardingCompleteIndexLazyRouteImport = createFileRoute(
  '/_authenticated/onboarding/complete/',
)()
const AuthenticatedJobsJobIdIndexLazyRouteImport = createFileRoute(
  '/_authenticated/jobs/$jobId/',
)()
const AuthAuthTalentScoutIndexLazyRouteImport = createFileRoute(
  '/_auth/auth/talent-scout/',
)()
const AuthenticatedSettingsOperationLogOperation_idLazyRouteImport =
  createFileRoute('/_authenticated/settings/operation-log/$operation_id')()
const AuthenticatedSettingsDatabaseExportLazyRouteImport = createFileRoute(
  '/_authenticated/settings/database/export',
)()
const AuthenticatedJobsJobIdSourceCandidatesLazyRouteImport = createFileRoute(
  '/_authenticated/jobs/$jobId/source-candidates',
)()
const AuthenticatedJobsJobIdRefineLazyRouteImport = createFileRoute(
  '/_authenticated/jobs/$jobId/refine',
)()
const AuthenticatedJobsJobIdRecommendationsLazyRouteImport = createFileRoute(
  '/_authenticated/jobs/$jobId/recommendations',
)()
const AuthenticatedJobsJobIdClientSubmissionsLazyRouteImport = createFileRoute(
  '/_authenticated/jobs/$jobId/client-submissions',
)()
const AuthenticatedJobsJobIdAssessmentsIndexLazyRouteImport = createFileRoute(
  '/_authenticated/jobs/$jobId/assessments/',
)()
const AuthenticatedJobsJobIdConfigureTriggersLazyRouteImport = createFileRoute(
  '/_authenticated/jobs/$jobId/configure/triggers',
)()
const AuthenticatedJobsJobIdConfigurePublishLazyRouteImport = createFileRoute(
  '/_authenticated/jobs/$jobId/configure/publish',
)()
const AuthenticatedJobsJobIdConfigureExportLazyRouteImport = createFileRoute(
  '/_authenticated/jobs/$jobId/configure/export',
)()
const AuthenticatedJobsJobIdCandidateIdLazyRouteImport = createFileRoute(
  '/_authenticated/jobs/$jobId/candidate/$id',
)()

const AcceptInviteRoute = AcceptInviteRouteImport.update({
  id: '/accept-invite',
  path: '/accept-invite',
  getParentRoute: () => rootRouteImport,
} as any)
const OrganizationsRouteRoute = OrganizationsRouteRouteImport.update({
  id: '/organizations',
  path: '/organizations',
  getParentRoute: () => rootRouteImport,
} as any)
const OneauthRouteRoute = OneauthRouteRouteImport.update({
  id: '/oneauth',
  path: '/oneauth',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRouteRoute = OnboardingRouteRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRouteRoute = AuthRouteRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const OrganizationsIndexLazyRoute = OrganizationsIndexLazyRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OrganizationsRouteRoute,
} as any).lazy(() =>
  import('./routes/organizations/index.lazy').then((d) => d.Route),
)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const OrgNotFoundLazyRoute = OrgNotFoundLazyRouteImport.update({
  id: '/org/not-found',
  path: '/org/not-found',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/org/not-found.lazy').then((d) => d.Route))
const OneauthConnectLazyRoute = OneauthConnectLazyRouteImport.update({
  id: '/connect',
  path: '/connect',
  getParentRoute: () => OneauthRouteRoute,
} as any).lazy(() =>
  import('./routes/oneauth/connect.lazy').then((d) => d.Route),
)
const OneauthTokenLazyRoute = OneauthTokenLazyRouteImport.update({
  id: '/$token',
  path: '/$token',
  getParentRoute: () => OneauthRouteRoute,
} as any).lazy(() =>
  import('./routes/oneauth/$token.lazy').then((d) => d.Route),
)
const AuthenticatedApplicationsLazyRoute =
  AuthenticatedApplicationsLazyRouteImport.update({
    id: '/applications',
    path: '/applications',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/applications.lazy').then((d) => d.Route),
  )
const AuthForgotPasswordLazyRoute = AuthForgotPasswordLazyRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/forgot-password.lazy').then((d) => d.Route),
)
const errors503LazyRoute = errors503LazyRouteImport
  .update({
    id: '/(errors)/503',
    path: '/503',
    getParentRoute: () => rootRouteImport,
  } as any)
  .lazy(() => import('./routes/(errors)/503.lazy').then((d) => d.Route))
const errors500LazyRoute = errors500LazyRouteImport
  .update({
    id: '/(errors)/500',
    path: '/500',
    getParentRoute: () => rootRouteImport,
  } as any)
  .lazy(() => import('./routes/(errors)/500.lazy').then((d) => d.Route))
const errors404LazyRoute = errors404LazyRouteImport
  .update({
    id: '/(errors)/404',
    path: '/404',
    getParentRoute: () => rootRouteImport,
  } as any)
  .lazy(() => import('./routes/(errors)/404.lazy').then((d) => d.Route))
const errors403LazyRoute = errors403LazyRouteImport
  .update({
    id: '/(errors)/403',
    path: '/403',
    getParentRoute: () => rootRouteImport,
  } as any)
  .lazy(() => import('./routes/(errors)/403.lazy').then((d) => d.Route))
const errors401LazyRoute = errors401LazyRouteImport
  .update({
    id: '/(errors)/401',
    path: '/401',
    getParentRoute: () => rootRouteImport,
  } as any)
  .lazy(() => import('./routes/(errors)/401.lazy').then((d) => d.Route))
const AuthenticatedSettingsRouteLazyRoute =
  AuthenticatedSettingsRouteLazyRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/route.lazy').then((d) => d.Route),
  )
const ScheduleTokenRoute = ScheduleTokenRouteImport.update({
  id: '/schedule/$token',
  path: '/schedule/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const PortfolioUserIdRoute = PortfolioUserIdRouteImport.update({
  id: '/portfolio/$userId',
  path: '/portfolio/$userId',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthSignInRoute = AuthSignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() => import('./routes/_auth/login.lazy').then((d) => d.Route))
const OnboardingProfileRouteRoute = OnboardingProfileRouteRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => OnboardingRouteRoute,
} as any)
const OnboardingRouteWapperRouteRoute =
  OnboardingRouteWapperRouteRouteImport.update({
    id: '/_route-wapper',
    getParentRoute: () => OnboardingRouteRoute,
  } as any)
const OauthCallbacksCallbackRouteRoute =
  OauthCallbacksCallbackRouteRouteImport.update({
    id: '/_oauth-callbacks/callback',
    path: '/callback',
    getParentRoute: () => rootRouteImport,
  } as any)
const OnboardingProfileIndexLazyRoute =
  OnboardingProfileIndexLazyRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => OnboardingProfileRouteRoute,
  } as any).lazy(() =>
    import('./routes/onboarding/profile/index.lazy').then((d) => d.Route),
  )
const AuthenticatedSupportIndexLazyRoute =
  AuthenticatedSupportIndexLazyRouteImport.update({
    id: '/support/',
    path: '/support/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/support/index.lazy').then((d) => d.Route),
  )
const AuthenticatedSettingsIndexLazyRoute =
  AuthenticatedSettingsIndexLazyRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/index.lazy').then((d) => d.Route),
  )
const AuthenticatedSalaryInsightsIndexLazyRoute =
  AuthenticatedSalaryInsightsIndexLazyRouteImport.update({
    id: '/salary-insights/',
    path: '/salary-insights/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/salary-insights/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedRoadmapsIndexLazyRoute =
  AuthenticatedRoadmapsIndexLazyRouteImport.update({
    id: '/roadmaps/',
    path: '/roadmaps/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/roadmaps/index.lazy').then((d) => d.Route),
  )
const AuthenticatedResumeBuilderIndexLazyRoute =
  AuthenticatedResumeBuilderIndexLazyRouteImport.update({
    id: '/resume-builder/',
    path: '/resume-builder/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/resume-builder/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedProfileIndexLazyRoute =
  AuthenticatedProfileIndexLazyRouteImport.update({
    id: '/profile/',
    path: '/profile/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/profile/index.lazy').then((d) => d.Route),
  )
const AuthenticatedPracticeIndexLazyRoute =
  AuthenticatedPracticeIndexLazyRouteImport.update({
    id: '/practice/',
    path: '/practice/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/practice/index.lazy').then((d) => d.Route),
  )
const AuthenticatedLearningHubIndexLazyRoute =
  AuthenticatedLearningHubIndexLazyRouteImport.update({
    id: '/learning-hub/',
    path: '/learning-hub/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/learning-hub/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedLeaderboardsIndexLazyRoute =
  AuthenticatedLeaderboardsIndexLazyRouteImport.update({
    id: '/leaderboards/',
    path: '/leaderboards/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/leaderboards/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedJobsIndexLazyRoute =
  AuthenticatedJobsIndexLazyRouteImport.update({
    id: '/jobs/',
    path: '/jobs/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/jobs/index.lazy').then((d) => d.Route),
  )
const AuthenticatedInterviewsIndexLazyRoute =
  AuthenticatedInterviewsIndexLazyRouteImport.update({
    id: '/interviews/',
    path: '/interviews/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/interviews/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedHelpCenterIndexLazyRoute =
  AuthenticatedHelpCenterIndexLazyRouteImport.update({
    id: '/help-center/',
    path: '/help-center/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/help-center/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedDiscussionsIndexLazyRoute =
  AuthenticatedDiscussionsIndexLazyRouteImport.update({
    id: '/discussions/',
    path: '/discussions/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/discussions/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedAtsCheckerIndexLazyRoute =
  AuthenticatedAtsCheckerIndexLazyRouteImport.update({
    id: '/ats-checker/',
    path: '/ats-checker/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/ats-checker/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedAssessmentsIndexLazyRoute =
  AuthenticatedAssessmentsIndexLazyRouteImport.update({
    id: '/assessments/',
    path: '/assessments/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/assessments/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthSignUpIndexLazyRoute = AuthSignUpIndexLazyRouteImport.update({
  id: '/sign-up/',
  path: '/sign-up/',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/sign-up/index.lazy').then((d) => d.Route),
)
const ReportsCandidateReportRidLazyRoute =
  ReportsCandidateReportRidLazyRouteImport.update({
    id: '/reports/candidate-report/$rid',
    path: '/reports/candidate-report/$rid',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/reports/candidate-report/$rid.lazy').then((d) => d.Route),
  )
const OnboardingRouteWapperSuccessLazyRoute =
  OnboardingRouteWapperSuccessLazyRouteImport.update({
    id: '/success',
    path: '/success',
    getParentRoute: () => OnboardingRouteWapperRouteRoute,
  } as any).lazy(() =>
    import('./routes/onboarding/_route-wapper/success.lazy').then(
      (d) => d.Route,
    ),
  )
const OnboardingRouteWapperCreateOrgLazyRoute =
  OnboardingRouteWapperCreateOrgLazyRouteImport.update({
    id: '/create-org',
    path: '/create-org',
    getParentRoute: () => OnboardingRouteWapperRouteRoute,
  } as any).lazy(() =>
    import('./routes/onboarding/_route-wapper/create-org.lazy').then(
      (d) => d.Route,
    ),
  )
const OauthCallbacksCallbackZoomOauthLazyRoute =
  OauthCallbacksCallbackZoomOauthLazyRouteImport.update({
    id: '/zoom-oauth',
    path: '/zoom-oauth',
    getParentRoute: () => OauthCallbacksCallbackRouteRoute,
  } as any).lazy(() =>
    import('./routes/_oauth-callbacks/callback/zoom-oauth.lazy').then(
      (d) => d.Route,
    ),
  )
const OauthCallbacksCallbackMicrosoftOauthLazyRoute =
  OauthCallbacksCallbackMicrosoftOauthLazyRouteImport.update({
    id: '/microsoft-oauth',
    path: '/microsoft-oauth',
    getParentRoute: () => OauthCallbacksCallbackRouteRoute,
  } as any).lazy(() =>
    import('./routes/_oauth-callbacks/callback/microsoft-oauth.lazy').then(
      (d) => d.Route,
    ),
  )
const OauthCallbacksCallbackGoogleOauthLazyRoute =
  OauthCallbacksCallbackGoogleOauthLazyRouteImport.update({
    id: '/google-oauth',
    path: '/google-oauth',
    getParentRoute: () => OauthCallbacksCallbackRouteRoute,
  } as any).lazy(() =>
    import('./routes/_oauth-callbacks/callback/google-oauth.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsPipelinesLazyRoute =
  AuthenticatedSettingsPipelinesLazyRouteImport.update({
    id: '/pipelines',
    path: '/pipelines',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/pipelines.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsCommunicationsLazyRoute =
  AuthenticatedSettingsCommunicationsLazyRouteImport.update({
    id: '/communications',
    path: '/communications',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/communications.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsCareerPagesLazyRoute =
  AuthenticatedSettingsCareerPagesLazyRouteImport.update({
    id: '/career-pages',
    path: '/career-pages',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/career-pages.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsBillingLazyRoute =
  AuthenticatedSettingsBillingLazyRouteImport.update({
    id: '/billing',
    path: '/billing',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/billing.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsActivityLogLazyRoute =
  AuthenticatedSettingsActivityLogLazyRouteImport.update({
    id: '/activity-log',
    path: '/activity-log',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/activity-log.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedJobsCreateLazyRoute =
  AuthenticatedJobsCreateLazyRouteImport.update({
    id: '/jobs/create',
    path: '/jobs/create',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/jobs/create.lazy').then((d) => d.Route),
  )
const AuthenticatedAssessmentsAssessmentIdLazyRoute =
  AuthenticatedAssessmentsAssessmentIdLazyRouteImport.update({
    id: '/assessments/$assessmentId',
    path: '/assessments/$assessmentId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/assessments/$assessmentId.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthSignUpEmailSentLazyRoute = AuthSignUpEmailSentLazyRouteImport.update({
  id: '/sign-up/email-sent',
  path: '/sign-up/email-sent',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/sign-up/email-sent.lazy').then((d) => d.Route),
)
const AuthenticatedSettingsManageTeamRoute =
  AuthenticatedSettingsManageTeamRouteImport.update({
    id: '/manage-team',
    path: '/manage-team',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any)
const AuthAuthSetPasswordRoute = AuthAuthSetPasswordRouteImport.update({
  id: '/auth/set-password',
  path: '/auth/set-password',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthenticatedJobsJobIdRouteRoute =
  AuthenticatedJobsJobIdRouteRouteImport.update({
    id: '/jobs/$jobId',
    path: '/jobs/$jobId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthAuthTalentScoutRouteRoute =
  AuthAuthTalentScoutRouteRouteImport.update({
    id: '/auth/talent-scout',
    path: '/auth/talent-scout',
    getParentRoute: () => AuthRouteRoute,
  } as any)
const AuthenticatedSettingsOperationLogIndexLazyRoute =
  AuthenticatedSettingsOperationLogIndexLazyRouteImport.update({
    id: '/operation-log/',
    path: '/operation-log/',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/operation-log/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedOnboardingCompleteIndexLazyRoute =
  AuthenticatedOnboardingCompleteIndexLazyRouteImport.update({
    id: '/onboarding/complete/',
    path: '/onboarding/complete/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/onboarding/complete/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedJobsJobIdIndexLazyRoute =
  AuthenticatedJobsJobIdIndexLazyRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedJobsJobIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/jobs/$jobId/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthAuthTalentScoutIndexLazyRoute =
  AuthAuthTalentScoutIndexLazyRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthAuthTalentScoutRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth/auth/talent-scout/index.lazy').then((d) => d.Route),
  )
const AuthAuthCallbackIndexRoute = AuthAuthCallbackIndexRouteImport.update({
  id: '/auth/callback/',
  path: '/auth/callback/',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthenticatedSettingsOperationLogOperation_idLazyRoute =
  AuthenticatedSettingsOperationLogOperation_idLazyRouteImport.update({
    id: '/operation-log/$operation_id',
    path: '/operation-log/$operation_id',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import(
      './routes/_authenticated/settings/operation-log/$operation_id.lazy'
    ).then((d) => d.Route),
  )
const AuthenticatedSettingsDatabaseExportLazyRoute =
  AuthenticatedSettingsDatabaseExportLazyRouteImport.update({
    id: '/database/export',
    path: '/database/export',
    getParentRoute: () => AuthenticatedSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings/database/export.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedJobsJobIdSourceCandidatesLazyRoute =
  AuthenticatedJobsJobIdSourceCandidatesLazyRouteImport.update({
    id: '/source-candidates',
    path: '/source-candidates',
    getParentRoute: () => AuthenticatedJobsJobIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/jobs/$jobId/source-candidates.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedJobsJobIdRefineLazyRoute =
  AuthenticatedJobsJobIdRefineLazyRouteImport.update({
    id: '/refine',
    path: '/refine',
    getParentRoute: () => AuthenticatedJobsJobIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/jobs/$jobId/refine.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedJobsJobIdRecommendationsLazyRoute =
  AuthenticatedJobsJobIdRecommendationsLazyRouteImport.update({
    id: '/recommendations',
    path: '/recommendations',
    getParentRoute: () => AuthenticatedJobsJobIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/jobs/$jobId/recommendations.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedJobsJobIdClientSubmissionsLazyRoute =
  AuthenticatedJobsJobIdClientSubmissionsLazyRouteImport.update({
    id: '/client-submissions',
    path: '/client-submissions',
    getParentRoute: () => AuthenticatedJobsJobIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/jobs/$jobId/client-submissions.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedJobsJobIdConfigureRouteRoute =
  AuthenticatedJobsJobIdConfigureRouteRouteImport.update({
    id: '/configure',
    path: '/configure',
    getParentRoute: () => AuthenticatedJobsJobIdRouteRoute,
  } as any)
const AuthenticatedJobsJobIdAssessmentsIndexLazyRoute =
  AuthenticatedJobsJobIdAssessmentsIndexLazyRouteImport.update({
    id: '/assessments/',
    path: '/assessments/',
    getParentRoute: () => AuthenticatedJobsJobIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/jobs/$jobId/assessments/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedJobsJobIdConfigureTriggersLazyRoute =
  AuthenticatedJobsJobIdConfigureTriggersLazyRouteImport.update({
    id: '/triggers',
    path: '/triggers',
    getParentRoute: () => AuthenticatedJobsJobIdConfigureRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/jobs/$jobId/configure/triggers.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedJobsJobIdConfigurePublishLazyRoute =
  AuthenticatedJobsJobIdConfigurePublishLazyRouteImport.update({
    id: '/publish',
    path: '/publish',
    getParentRoute: () => AuthenticatedJobsJobIdConfigureRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/jobs/$jobId/configure/publish.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedJobsJobIdConfigureExportLazyRoute =
  AuthenticatedJobsJobIdConfigureExportLazyRouteImport.update({
    id: '/export',
    path: '/export',
    getParentRoute: () => AuthenticatedJobsJobIdConfigureRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/jobs/$jobId/configure/export.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedJobsJobIdCandidateIdLazyRoute =
  AuthenticatedJobsJobIdCandidateIdLazyRouteImport.update({
    id: '/candidate/$id',
    path: '/candidate/$id',
    getParentRoute: () => AuthenticatedJobsJobIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/jobs/$jobId/candidate.$id.lazy').then(
      (d) => d.Route,
    ),
  )

export interface FileRoutesByFullPath {
  '/onboarding': typeof OnboardingRouteWapperRouteRouteWithChildren
  '/oneauth': typeof OneauthRouteRouteWithChildren
  '/organizations': typeof OrganizationsRouteRouteWithChildren
  '/accept-invite': typeof AcceptInviteRoute
  '/callback': typeof OauthCallbacksCallbackRouteRouteWithChildren
  '/onboarding/profile': typeof OnboardingProfileRouteRouteWithChildren
  '/login': typeof AuthLoginRoute
  '/sign-in': typeof AuthSignInRoute
  '/portfolio/$userId': typeof PortfolioUserIdRoute
  '/schedule/$token': typeof ScheduleTokenRoute
  '/settings': typeof AuthenticatedSettingsRouteLazyRouteWithChildren
  '/401': typeof errors401LazyRoute
  '/403': typeof errors403LazyRoute
  '/404': typeof errors404LazyRoute
  '/500': typeof errors500LazyRoute
  '/503': typeof errors503LazyRoute
  '/forgot-password': typeof AuthForgotPasswordLazyRoute
  '/applications': typeof AuthenticatedApplicationsLazyRoute
  '/oneauth/$token': typeof OneauthTokenLazyRoute
  '/oneauth/connect': typeof OneauthConnectLazyRoute
  '/org/not-found': typeof OrgNotFoundLazyRoute
  '/': typeof AuthenticatedIndexRoute
  '/organizations/': typeof OrganizationsIndexLazyRoute
  '/auth/talent-scout': typeof AuthAuthTalentScoutRouteRouteWithChildren
  '/jobs/$jobId': typeof AuthenticatedJobsJobIdRouteRouteWithChildren
  '/auth/set-password': typeof AuthAuthSetPasswordRoute
  '/settings/manage-team': typeof AuthenticatedSettingsManageTeamRoute
  '/sign-up/email-sent': typeof AuthSignUpEmailSentLazyRoute
  '/assessments/$assessmentId': typeof AuthenticatedAssessmentsAssessmentIdLazyRoute
  '/jobs/create': typeof AuthenticatedJobsCreateLazyRoute
  '/settings/activity-log': typeof AuthenticatedSettingsActivityLogLazyRoute
  '/settings/billing': typeof AuthenticatedSettingsBillingLazyRoute
  '/settings/career-pages': typeof AuthenticatedSettingsCareerPagesLazyRoute
  '/settings/communications': typeof AuthenticatedSettingsCommunicationsLazyRoute
  '/settings/pipelines': typeof AuthenticatedSettingsPipelinesLazyRoute
  '/callback/google-oauth': typeof OauthCallbacksCallbackGoogleOauthLazyRoute
  '/callback/microsoft-oauth': typeof OauthCallbacksCallbackMicrosoftOauthLazyRoute
  '/callback/zoom-oauth': typeof OauthCallbacksCallbackZoomOauthLazyRoute
  '/onboarding/create-org': typeof OnboardingRouteWapperCreateOrgLazyRoute
  '/onboarding/success': typeof OnboardingRouteWapperSuccessLazyRoute
  '/reports/candidate-report/$rid': typeof ReportsCandidateReportRidLazyRoute
  '/sign-up': typeof AuthSignUpIndexLazyRoute
  '/assessments': typeof AuthenticatedAssessmentsIndexLazyRoute
  '/ats-checker': typeof AuthenticatedAtsCheckerIndexLazyRoute
  '/discussions': typeof AuthenticatedDiscussionsIndexLazyRoute
  '/help-center': typeof AuthenticatedHelpCenterIndexLazyRoute
  '/interviews': typeof AuthenticatedInterviewsIndexLazyRoute
  '/jobs': typeof AuthenticatedJobsIndexLazyRoute
  '/leaderboards': typeof AuthenticatedLeaderboardsIndexLazyRoute
  '/learning-hub': typeof AuthenticatedLearningHubIndexLazyRoute
  '/practice': typeof AuthenticatedPracticeIndexLazyRoute
  '/profile': typeof AuthenticatedProfileIndexLazyRoute
  '/resume-builder': typeof AuthenticatedResumeBuilderIndexLazyRoute
  '/roadmaps': typeof AuthenticatedRoadmapsIndexLazyRoute
  '/salary-insights': typeof AuthenticatedSalaryInsightsIndexLazyRoute
  '/settings/': typeof AuthenticatedSettingsIndexLazyRoute
  '/support': typeof AuthenticatedSupportIndexLazyRoute
  '/onboarding/profile/': typeof OnboardingProfileIndexLazyRoute
  '/jobs/$jobId/configure': typeof AuthenticatedJobsJobIdConfigureRouteRouteWithChildren
  '/jobs/$jobId/client-submissions': typeof AuthenticatedJobsJobIdClientSubmissionsLazyRoute
  '/jobs/$jobId/recommendations': typeof AuthenticatedJobsJobIdRecommendationsLazyRoute
  '/jobs/$jobId/refine': typeof AuthenticatedJobsJobIdRefineLazyRoute
  '/jobs/$jobId/source-candidates': typeof AuthenticatedJobsJobIdSourceCandidatesLazyRoute
  '/settings/database/export': typeof AuthenticatedSettingsDatabaseExportLazyRoute
  '/settings/operation-log/$operation_id': typeof AuthenticatedSettingsOperationLogOperation_idLazyRoute
  '/auth/callback': typeof AuthAuthCallbackIndexRoute
  '/auth/talent-scout/': typeof AuthAuthTalentScoutIndexLazyRoute
  '/jobs/$jobId/': typeof AuthenticatedJobsJobIdIndexLazyRoute
  '/onboarding/complete': typeof AuthenticatedOnboardingCompleteIndexLazyRoute
  '/settings/operation-log': typeof AuthenticatedSettingsOperationLogIndexLazyRoute
  '/jobs/$jobId/candidate/$id': typeof AuthenticatedJobsJobIdCandidateIdLazyRoute
  '/jobs/$jobId/configure/export': typeof AuthenticatedJobsJobIdConfigureExportLazyRoute
  '/jobs/$jobId/configure/publish': typeof AuthenticatedJobsJobIdConfigurePublishLazyRoute
  '/jobs/$jobId/configure/triggers': typeof AuthenticatedJobsJobIdConfigureTriggersLazyRoute
  '/jobs/$jobId/assessments': typeof AuthenticatedJobsJobIdAssessmentsIndexLazyRoute
}
export interface FileRoutesByTo {
  '/onboarding': typeof OnboardingRouteWapperRouteRouteWithChildren
  '/oneauth': typeof OneauthRouteRouteWithChildren
  '/accept-invite': typeof AcceptInviteRoute
  '/callback': typeof OauthCallbacksCallbackRouteRouteWithChildren
  '/login': typeof AuthLoginRoute
  '/sign-in': typeof AuthSignInRoute
  '/portfolio/$userId': typeof PortfolioUserIdRoute
  '/schedule/$token': typeof ScheduleTokenRoute
  '/401': typeof errors401LazyRoute
  '/403': typeof errors403LazyRoute
  '/404': typeof errors404LazyRoute
  '/500': typeof errors500LazyRoute
  '/503': typeof errors503LazyRoute
  '/forgot-password': typeof AuthForgotPasswordLazyRoute
  '/applications': typeof AuthenticatedApplicationsLazyRoute
  '/oneauth/$token': typeof OneauthTokenLazyRoute
  '/oneauth/connect': typeof OneauthConnectLazyRoute
  '/org/not-found': typeof OrgNotFoundLazyRoute
  '/': typeof AuthenticatedIndexRoute
  '/organizations': typeof OrganizationsIndexLazyRoute
  '/auth/set-password': typeof AuthAuthSetPasswordRoute
  '/settings/manage-team': typeof AuthenticatedSettingsManageTeamRoute
  '/sign-up/email-sent': typeof AuthSignUpEmailSentLazyRoute
  '/assessments/$assessmentId': typeof AuthenticatedAssessmentsAssessmentIdLazyRoute
  '/jobs/create': typeof AuthenticatedJobsCreateLazyRoute
  '/settings/activity-log': typeof AuthenticatedSettingsActivityLogLazyRoute
  '/settings/billing': typeof AuthenticatedSettingsBillingLazyRoute
  '/settings/career-pages': typeof AuthenticatedSettingsCareerPagesLazyRoute
  '/settings/communications': typeof AuthenticatedSettingsCommunicationsLazyRoute
  '/settings/pipelines': typeof AuthenticatedSettingsPipelinesLazyRoute
  '/callback/google-oauth': typeof OauthCallbacksCallbackGoogleOauthLazyRoute
  '/callback/microsoft-oauth': typeof OauthCallbacksCallbackMicrosoftOauthLazyRoute
  '/callback/zoom-oauth': typeof OauthCallbacksCallbackZoomOauthLazyRoute
  '/onboarding/create-org': typeof OnboardingRouteWapperCreateOrgLazyRoute
  '/onboarding/success': typeof OnboardingRouteWapperSuccessLazyRoute
  '/reports/candidate-report/$rid': typeof ReportsCandidateReportRidLazyRoute
  '/sign-up': typeof AuthSignUpIndexLazyRoute
  '/assessments': typeof AuthenticatedAssessmentsIndexLazyRoute
  '/ats-checker': typeof AuthenticatedAtsCheckerIndexLazyRoute
  '/discussions': typeof AuthenticatedDiscussionsIndexLazyRoute
  '/help-center': typeof AuthenticatedHelpCenterIndexLazyRoute
  '/interviews': typeof AuthenticatedInterviewsIndexLazyRoute
  '/jobs': typeof AuthenticatedJobsIndexLazyRoute
  '/leaderboards': typeof AuthenticatedLeaderboardsIndexLazyRoute
  '/learning-hub': typeof AuthenticatedLearningHubIndexLazyRoute
  '/practice': typeof AuthenticatedPracticeIndexLazyRoute
  '/profile': typeof AuthenticatedProfileIndexLazyRoute
  '/resume-builder': typeof AuthenticatedResumeBuilderIndexLazyRoute
  '/roadmaps': typeof AuthenticatedRoadmapsIndexLazyRoute
  '/salary-insights': typeof AuthenticatedSalaryInsightsIndexLazyRoute
  '/settings': typeof AuthenticatedSettingsIndexLazyRoute
  '/support': typeof AuthenticatedSupportIndexLazyRoute
  '/onboarding/profile': typeof OnboardingProfileIndexLazyRoute
  '/jobs/$jobId/configure': typeof AuthenticatedJobsJobIdConfigureRouteRouteWithChildren
  '/jobs/$jobId/client-submissions': typeof AuthenticatedJobsJobIdClientSubmissionsLazyRoute
  '/jobs/$jobId/recommendations': typeof AuthenticatedJobsJobIdRecommendationsLazyRoute
  '/jobs/$jobId/refine': typeof AuthenticatedJobsJobIdRefineLazyRoute
  '/jobs/$jobId/source-candidates': typeof AuthenticatedJobsJobIdSourceCandidatesLazyRoute
  '/settings/database/export': typeof AuthenticatedSettingsDatabaseExportLazyRoute
  '/settings/operation-log/$operation_id': typeof AuthenticatedSettingsOperationLogOperation_idLazyRoute
  '/auth/callback': typeof AuthAuthCallbackIndexRoute
  '/auth/talent-scout': typeof AuthAuthTalentScoutIndexLazyRoute
  '/jobs/$jobId': typeof AuthenticatedJobsJobIdIndexLazyRoute
  '/onboarding/complete': typeof AuthenticatedOnboardingCompleteIndexLazyRoute
  '/settings/operation-log': typeof AuthenticatedSettingsOperationLogIndexLazyRoute
  '/jobs/$jobId/candidate/$id': typeof AuthenticatedJobsJobIdCandidateIdLazyRoute
  '/jobs/$jobId/configure/export': typeof AuthenticatedJobsJobIdConfigureExportLazyRoute
  '/jobs/$jobId/configure/publish': typeof AuthenticatedJobsJobIdConfigurePublishLazyRoute
  '/jobs/$jobId/configure/triggers': typeof AuthenticatedJobsJobIdConfigureTriggersLazyRoute
  '/jobs/$jobId/assessments': typeof AuthenticatedJobsJobIdAssessmentsIndexLazyRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth': typeof AuthRouteRouteWithChildren
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/onboarding': typeof OnboardingRouteRouteWithChildren
  '/oneauth': typeof OneauthRouteRouteWithChildren
  '/organizations': typeof OrganizationsRouteRouteWithChildren
  '/accept-invite': typeof AcceptInviteRoute
  '/_oauth-callbacks/callback': typeof OauthCallbacksCallbackRouteRouteWithChildren
  '/onboarding/_route-wapper': typeof OnboardingRouteWapperRouteRouteWithChildren
  '/onboarding/profile': typeof OnboardingProfileRouteRouteWithChildren
  '/_auth/login': typeof AuthLoginRoute
  '/_auth/sign-in': typeof AuthSignInRoute
  '/portfolio/$userId': typeof PortfolioUserIdRoute
  '/schedule/$token': typeof ScheduleTokenRoute
  '/_authenticated/settings': typeof AuthenticatedSettingsRouteLazyRouteWithChildren
  '/(errors)/401': typeof errors401LazyRoute
  '/(errors)/403': typeof errors403LazyRoute
  '/(errors)/404': typeof errors404LazyRoute
  '/(errors)/500': typeof errors500LazyRoute
  '/(errors)/503': typeof errors503LazyRoute
  '/_auth/forgot-password': typeof AuthForgotPasswordLazyRoute
  '/_authenticated/applications': typeof AuthenticatedApplicationsLazyRoute
  '/oneauth/$token': typeof OneauthTokenLazyRoute
  '/oneauth/connect': typeof OneauthConnectLazyRoute
  '/org/not-found': typeof OrgNotFoundLazyRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/organizations/': typeof OrganizationsIndexLazyRoute
  '/_auth/auth/talent-scout': typeof AuthAuthTalentScoutRouteRouteWithChildren
  '/_authenticated/jobs/$jobId': typeof AuthenticatedJobsJobIdRouteRouteWithChildren
  '/_auth/auth/set-password': typeof AuthAuthSetPasswordRoute
  '/_authenticated/settings/manage-team': typeof AuthenticatedSettingsManageTeamRoute
  '/_auth/sign-up/email-sent': typeof AuthSignUpEmailSentLazyRoute
  '/_authenticated/assessments/$assessmentId': typeof AuthenticatedAssessmentsAssessmentIdLazyRoute
  '/_authenticated/jobs/create': typeof AuthenticatedJobsCreateLazyRoute
  '/_authenticated/settings/activity-log': typeof AuthenticatedSettingsActivityLogLazyRoute
  '/_authenticated/settings/billing': typeof AuthenticatedSettingsBillingLazyRoute
  '/_authenticated/settings/career-pages': typeof AuthenticatedSettingsCareerPagesLazyRoute
  '/_authenticated/settings/communications': typeof AuthenticatedSettingsCommunicationsLazyRoute
  '/_authenticated/settings/pipelines': typeof AuthenticatedSettingsPipelinesLazyRoute
  '/_oauth-callbacks/callback/google-oauth': typeof OauthCallbacksCallbackGoogleOauthLazyRoute
  '/_oauth-callbacks/callback/microsoft-oauth': typeof OauthCallbacksCallbackMicrosoftOauthLazyRoute
  '/_oauth-callbacks/callback/zoom-oauth': typeof OauthCallbacksCallbackZoomOauthLazyRoute
  '/onboarding/_route-wapper/create-org': typeof OnboardingRouteWapperCreateOrgLazyRoute
  '/onboarding/_route-wapper/success': typeof OnboardingRouteWapperSuccessLazyRoute
  '/reports/candidate-report/$rid': typeof ReportsCandidateReportRidLazyRoute
  '/_auth/sign-up/': typeof AuthSignUpIndexLazyRoute
  '/_authenticated/assessments/': typeof AuthenticatedAssessmentsIndexLazyRoute
  '/_authenticated/ats-checker/': typeof AuthenticatedAtsCheckerIndexLazyRoute
  '/_authenticated/discussions/': typeof AuthenticatedDiscussionsIndexLazyRoute
  '/_authenticated/help-center/': typeof AuthenticatedHelpCenterIndexLazyRoute
  '/_authenticated/interviews/': typeof AuthenticatedInterviewsIndexLazyRoute
  '/_authenticated/jobs/': typeof AuthenticatedJobsIndexLazyRoute
  '/_authenticated/leaderboards/': typeof AuthenticatedLeaderboardsIndexLazyRoute
  '/_authenticated/learning-hub/': typeof AuthenticatedLearningHubIndexLazyRoute
  '/_authenticated/practice/': typeof AuthenticatedPracticeIndexLazyRoute
  '/_authenticated/profile/': typeof AuthenticatedProfileIndexLazyRoute
  '/_authenticated/resume-builder/': typeof AuthenticatedResumeBuilderIndexLazyRoute
  '/_authenticated/roadmaps/': typeof AuthenticatedRoadmapsIndexLazyRoute
  '/_authenticated/salary-insights/': typeof AuthenticatedSalaryInsightsIndexLazyRoute
  '/_authenticated/settings/': typeof AuthenticatedSettingsIndexLazyRoute
  '/_authenticated/support/': typeof AuthenticatedSupportIndexLazyRoute
  '/onboarding/profile/': typeof OnboardingProfileIndexLazyRoute
  '/_authenticated/jobs/$jobId/configure': typeof AuthenticatedJobsJobIdConfigureRouteRouteWithChildren
  '/_authenticated/jobs/$jobId/client-submissions': typeof AuthenticatedJobsJobIdClientSubmissionsLazyRoute
  '/_authenticated/jobs/$jobId/recommendations': typeof AuthenticatedJobsJobIdRecommendationsLazyRoute
  '/_authenticated/jobs/$jobId/refine': typeof AuthenticatedJobsJobIdRefineLazyRoute
  '/_authenticated/jobs/$jobId/source-candidates': typeof AuthenticatedJobsJobIdSourceCandidatesLazyRoute
  '/_authenticated/settings/database/export': typeof AuthenticatedSettingsDatabaseExportLazyRoute
  '/_authenticated/settings/operation-log/$operation_id': typeof AuthenticatedSettingsOperationLogOperation_idLazyRoute
  '/_auth/auth/callback/': typeof AuthAuthCallbackIndexRoute
  '/_auth/auth/talent-scout/': typeof AuthAuthTalentScoutIndexLazyRoute
  '/_authenticated/jobs/$jobId/': typeof AuthenticatedJobsJobIdIndexLazyRoute
  '/_authenticated/onboarding/complete/': typeof AuthenticatedOnboardingCompleteIndexLazyRoute
  '/_authenticated/settings/operation-log/': typeof AuthenticatedSettingsOperationLogIndexLazyRoute
  '/_authenticated/jobs/$jobId/candidate/$id': typeof AuthenticatedJobsJobIdCandidateIdLazyRoute
  '/_authenticated/jobs/$jobId/configure/export': typeof AuthenticatedJobsJobIdConfigureExportLazyRoute
  '/_authenticated/jobs/$jobId/configure/publish': typeof AuthenticatedJobsJobIdConfigurePublishLazyRoute
  '/_authenticated/jobs/$jobId/configure/triggers': typeof AuthenticatedJobsJobIdConfigureTriggersLazyRoute
  '/_authenticated/jobs/$jobId/assessments/': typeof AuthenticatedJobsJobIdAssessmentsIndexLazyRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/onboarding'
    | '/oneauth'
    | '/organizations'
    | '/accept-invite'
    | '/callback'
    | '/onboarding/profile'
    | '/login'
    | '/sign-in'
    | '/portfolio/$userId'
    | '/schedule/$token'
    | '/settings'
    | '/401'
    | '/403'
    | '/404'
    | '/500'
    | '/503'
    | '/forgot-password'
    | '/applications'
    | '/oneauth/$token'
    | '/oneauth/connect'
    | '/org/not-found'
    | '/'
    | '/organizations/'
    | '/auth/talent-scout'
    | '/jobs/$jobId'
    | '/auth/set-password'
    | '/settings/manage-team'
    | '/sign-up/email-sent'
    | '/assessments/$assessmentId'
    | '/jobs/create'
    | '/settings/activity-log'
    | '/settings/billing'
    | '/settings/career-pages'
    | '/settings/communications'
    | '/settings/pipelines'
    | '/callback/google-oauth'
    | '/callback/microsoft-oauth'
    | '/callback/zoom-oauth'
    | '/onboarding/create-org'
    | '/onboarding/success'
    | '/reports/candidate-report/$rid'
    | '/sign-up'
    | '/assessments'
    | '/ats-checker'
    | '/discussions'
    | '/help-center'
    | '/interviews'
    | '/jobs'
    | '/leaderboards'
    | '/learning-hub'
    | '/practice'
    | '/profile'
    | '/resume-builder'
    | '/roadmaps'
    | '/salary-insights'
    | '/settings/'
    | '/support'
    | '/onboarding/profile/'
    | '/jobs/$jobId/configure'
    | '/jobs/$jobId/client-submissions'
    | '/jobs/$jobId/recommendations'
    | '/jobs/$jobId/refine'
    | '/jobs/$jobId/source-candidates'
    | '/settings/database/export'
    | '/settings/operation-log/$operation_id'
    | '/auth/callback'
    | '/auth/talent-scout/'
    | '/jobs/$jobId/'
    | '/onboarding/complete'
    | '/settings/operation-log'
    | '/jobs/$jobId/candidate/$id'
    | '/jobs/$jobId/configure/export'
    | '/jobs/$jobId/configure/publish'
    | '/jobs/$jobId/configure/triggers'
    | '/jobs/$jobId/assessments'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/onboarding'
    | '/oneauth'
    | '/accept-invite'
    | '/callback'
    | '/login'
    | '/sign-in'
    | '/portfolio/$userId'
    | '/schedule/$token'
    | '/401'
    | '/403'
    | '/404'
    | '/500'
    | '/503'
    | '/forgot-password'
    | '/applications'
    | '/oneauth/$token'
    | '/oneauth/connect'
    | '/org/not-found'
    | '/'
    | '/organizations'
    | '/auth/set-password'
    | '/settings/manage-team'
    | '/sign-up/email-sent'
    | '/assessments/$assessmentId'
    | '/jobs/create'
    | '/settings/activity-log'
    | '/settings/billing'
    | '/settings/career-pages'
    | '/settings/communications'
    | '/settings/pipelines'
    | '/callback/google-oauth'
    | '/callback/microsoft-oauth'
    | '/callback/zoom-oauth'
    | '/onboarding/create-org'
    | '/onboarding/success'
    | '/reports/candidate-report/$rid'
    | '/sign-up'
    | '/assessments'
    | '/ats-checker'
    | '/discussions'
    | '/help-center'
    | '/interviews'
    | '/jobs'
    | '/leaderboards'
    | '/learning-hub'
    | '/practice'
    | '/profile'
    | '/resume-builder'
    | '/roadmaps'
    | '/salary-insights'
    | '/settings'
    | '/support'
    | '/onboarding/profile'
    | '/jobs/$jobId/configure'
    | '/jobs/$jobId/client-submissions'
    | '/jobs/$jobId/recommendations'
    | '/jobs/$jobId/refine'
    | '/jobs/$jobId/source-candidates'
    | '/settings/database/export'
    | '/settings/operation-log/$operation_id'
    | '/auth/callback'
    | '/auth/talent-scout'
    | '/jobs/$jobId'
    | '/onboarding/complete'
    | '/settings/operation-log'
    | '/jobs/$jobId/candidate/$id'
    | '/jobs/$jobId/configure/export'
    | '/jobs/$jobId/configure/publish'
    | '/jobs/$jobId/configure/triggers'
    | '/jobs/$jobId/assessments'
  id:
    | '__root__'
    | '/_auth'
    | '/_authenticated'
    | '/onboarding'
    | '/oneauth'
    | '/organizations'
    | '/accept-invite'
    | '/_oauth-callbacks/callback'
    | '/onboarding/_route-wapper'
    | '/onboarding/profile'
    | '/_auth/login'
    | '/_auth/sign-in'
    | '/portfolio/$userId'
    | '/schedule/$token'
    | '/_authenticated/settings'
    | '/(errors)/401'
    | '/(errors)/403'
    | '/(errors)/404'
    | '/(errors)/500'
    | '/(errors)/503'
    | '/_auth/forgot-password'
    | '/_authenticated/applications'
    | '/oneauth/$token'
    | '/oneauth/connect'
    | '/org/not-found'
    | '/_authenticated/'
    | '/organizations/'
    | '/_auth/auth/talent-scout'
    | '/_authenticated/jobs/$jobId'
    | '/_auth/auth/set-password'
    | '/_authenticated/settings/manage-team'
    | '/_auth/sign-up/email-sent'
    | '/_authenticated/assessments/$assessmentId'
    | '/_authenticated/jobs/create'
    | '/_authenticated/settings/activity-log'
    | '/_authenticated/settings/billing'
    | '/_authenticated/settings/career-pages'
    | '/_authenticated/settings/communications'
    | '/_authenticated/settings/pipelines'
    | '/_oauth-callbacks/callback/google-oauth'
    | '/_oauth-callbacks/callback/microsoft-oauth'
    | '/_oauth-callbacks/callback/zoom-oauth'
    | '/onboarding/_route-wapper/create-org'
    | '/onboarding/_route-wapper/success'
    | '/reports/candidate-report/$rid'
    | '/_auth/sign-up/'
    | '/_authenticated/assessments/'
    | '/_authenticated/ats-checker/'
    | '/_authenticated/discussions/'
    | '/_authenticated/help-center/'
    | '/_authenticated/interviews/'
    | '/_authenticated/jobs/'
    | '/_authenticated/leaderboards/'
    | '/_authenticated/learning-hub/'
    | '/_authenticated/practice/'
    | '/_authenticated/profile/'
    | '/_authenticated/resume-builder/'
    | '/_authenticated/roadmaps/'
    | '/_authenticated/salary-insights/'
    | '/_authenticated/settings/'
    | '/_authenticated/support/'
    | '/onboarding/profile/'
    | '/_authenticated/jobs/$jobId/configure'
    | '/_authenticated/jobs/$jobId/client-submissions'
    | '/_authenticated/jobs/$jobId/recommendations'
    | '/_authenticated/jobs/$jobId/refine'
    | '/_authenticated/jobs/$jobId/source-candidates'
    | '/_authenticated/settings/database/export'
    | '/_authenticated/settings/operation-log/$operation_id'
    | '/_auth/auth/callback/'
    | '/_auth/auth/talent-scout/'
    | '/_authenticated/jobs/$jobId/'
    | '/_authenticated/onboarding/complete/'
    | '/_authenticated/settings/operation-log/'
    | '/_authenticated/jobs/$jobId/candidate/$id'
    | '/_authenticated/jobs/$jobId/configure/export'
    | '/_authenticated/jobs/$jobId/configure/publish'
    | '/_authenticated/jobs/$jobId/configure/triggers'
    | '/_authenticated/jobs/$jobId/assessments/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRouteRoute: typeof AuthRouteRouteWithChildren
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  OnboardingRouteRoute: typeof OnboardingRouteRouteWithChildren
  OneauthRouteRoute: typeof OneauthRouteRouteWithChildren
  OrganizationsRouteRoute: typeof OrganizationsRouteRouteWithChildren
  AcceptInviteRoute: typeof AcceptInviteRoute
  OauthCallbacksCallbackRouteRoute: typeof OauthCallbacksCallbackRouteRouteWithChildren
  PortfolioUserIdRoute: typeof PortfolioUserIdRoute
  ScheduleTokenRoute: typeof ScheduleTokenRoute
  errors401LazyRoute: typeof errors401LazyRoute
  errors403LazyRoute: typeof errors403LazyRoute
  errors404LazyRoute: typeof errors404LazyRoute
  errors500LazyRoute: typeof errors500LazyRoute
  errors503LazyRoute: typeof errors503LazyRoute
  OrgNotFoundLazyRoute: typeof OrgNotFoundLazyRoute
  ReportsCandidateReportRidLazyRoute: typeof ReportsCandidateReportRidLazyRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/accept-invite': {
      id: '/accept-invite'
      path: '/accept-invite'
      fullPath: '/accept-invite'
      preLoaderRoute: typeof AcceptInviteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/organizations': {
      id: '/organizations'
      path: '/organizations'
      fullPath: '/organizations'
      preLoaderRoute: typeof OrganizationsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/oneauth': {
      id: '/oneauth'
      path: '/oneauth'
      fullPath: '/oneauth'
      preLoaderRoute: typeof OneauthRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/organizations/': {
      id: '/organizations/'
      path: '/'
      fullPath: '/organizations/'
      preLoaderRoute: typeof OrganizationsIndexLazyRouteImport
      parentRoute: typeof OrganizationsRouteRoute
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/org/not-found': {
      id: '/org/not-found'
      path: '/org/not-found'
      fullPath: '/org/not-found'
      preLoaderRoute: typeof OrgNotFoundLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/oneauth/connect': {
      id: '/oneauth/connect'
      path: '/connect'
      fullPath: '/oneauth/connect'
      preLoaderRoute: typeof OneauthConnectLazyRouteImport
      parentRoute: typeof OneauthRouteRoute
    }
    '/oneauth/$token': {
      id: '/oneauth/$token'
      path: '/$token'
      fullPath: '/oneauth/$token'
      preLoaderRoute: typeof OneauthTokenLazyRouteImport
      parentRoute: typeof OneauthRouteRoute
    }
    '/_authenticated/applications': {
      id: '/_authenticated/applications'
      path: '/applications'
      fullPath: '/applications'
      preLoaderRoute: typeof AuthenticatedApplicationsLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_auth/forgot-password': {
      id: '/_auth/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/(errors)/503': {
      id: '/(errors)/503'
      path: '/503'
      fullPath: '/503'
      preLoaderRoute: typeof errors503LazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/500': {
      id: '/(errors)/500'
      path: '/500'
      fullPath: '/500'
      preLoaderRoute: typeof errors500LazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/404': {
      id: '/(errors)/404'
      path: '/404'
      fullPath: '/404'
      preLoaderRoute: typeof errors404LazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/403': {
      id: '/(errors)/403'
      path: '/403'
      fullPath: '/403'
      preLoaderRoute: typeof errors403LazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/401': {
      id: '/(errors)/401'
      path: '/401'
      fullPath: '/401'
      preLoaderRoute: typeof errors401LazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/schedule/$token': {
      id: '/schedule/$token'
      path: '/schedule/$token'
      fullPath: '/schedule/$token'
      preLoaderRoute: typeof ScheduleTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portfolio/$userId': {
      id: '/portfolio/$userId'
      path: '/portfolio/$userId'
      fullPath: '/portfolio/$userId'
      preLoaderRoute: typeof PortfolioUserIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/sign-in': {
      id: '/_auth/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof AuthSignInRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/login': {
      id: '/_auth/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/onboarding/profile': {
      id: '/onboarding/profile'
      path: '/profile'
      fullPath: '/onboarding/profile'
      preLoaderRoute: typeof OnboardingProfileRouteRouteImport
      parentRoute: typeof OnboardingRouteRoute
    }
    '/onboarding/_route-wapper': {
      id: '/onboarding/_route-wapper'
      path: ''
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteWapperRouteRouteImport
      parentRoute: typeof OnboardingRouteRoute
    }
    '/_oauth-callbacks/callback': {
      id: '/_oauth-callbacks/callback'
      path: '/callback'
      fullPath: '/callback'
      preLoaderRoute: typeof OauthCallbacksCallbackRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/profile/': {
      id: '/onboarding/profile/'
      path: '/'
      fullPath: '/onboarding/profile/'
      preLoaderRoute: typeof OnboardingProfileIndexLazyRouteImport
      parentRoute: typeof OnboardingProfileRouteRoute
    }
    '/_authenticated/support/': {
      id: '/_authenticated/support/'
      path: '/support'
      fullPath: '/support'
      preLoaderRoute: typeof AuthenticatedSupportIndexLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/settings/': {
      id: '/_authenticated/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthenticatedSettingsIndexLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/salary-insights/': {
      id: '/_authenticated/salary-insights/'
      path: '/salary-insights'
      fullPath: '/salary-insights'
      preLoaderRoute: typeof AuthenticatedSalaryInsightsIndexLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/roadmaps/': {
      id: '/_authenticated/roadmaps/'
      path: '/roadmaps'
      fullPath: '/roadmaps'
      preLoaderRoute: typeof AuthenticatedRoadmapsIndexLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/resume-builder/': {
      id: '/_authenticated/resume-builder/'
      path: '/resume-builder'
      fullPath: '/resume-builder'
      preLoaderRoute: typeof AuthenticatedResumeBuilderIndexLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/profile/': {
      id: '/_authenticated/profile/'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AuthenticatedProfileIndexLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/practice/': {
      id: '/_authenticated/practice/'
      path: '/practice'
      fullPath: '/practice'
      preLoaderRoute: typeof AuthenticatedPracticeIndexLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/learning-hub/': {
      id: '/_authenticated/learning-hub/'
      path: '/learning-hub'
      fullPath: '/learning-hub'
      preLoaderRoute: typeof AuthenticatedLearningHubIndexLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/leaderboards/': {
      id: '/_authenticated/leaderboards/'
      path: '/leaderboards'
      fullPath: '/leaderboards'
      preLoaderRoute: typeof AuthenticatedLeaderboardsIndexLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/jobs/': {
      id: '/_authenticated/jobs/'
      path: '/jobs'
      fullPath: '/jobs'
      preLoaderRoute: typeof AuthenticatedJobsIndexLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/interviews/': {
      id: '/_authenticated/interviews/'
      path: '/interviews'
      fullPath: '/interviews'
      preLoaderRoute: typeof AuthenticatedInterviewsIndexLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/help-center/': {
      id: '/_authenticated/help-center/'
      path: '/help-center'
      fullPath: '/help-center'
      preLoaderRoute: typeof AuthenticatedHelpCenterIndexLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/discussions/': {
      id: '/_authenticated/discussions/'
      path: '/discussions'
      fullPath: '/discussions'
      preLoaderRoute: typeof AuthenticatedDiscussionsIndexLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/ats-checker/': {
      id: '/_authenticated/ats-checker/'
      path: '/ats-checker'
      fullPath: '/ats-checker'
      preLoaderRoute: typeof AuthenticatedAtsCheckerIndexLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/assessments/': {
      id: '/_authenticated/assessments/'
      path: '/assessments'
      fullPath: '/assessments'
      preLoaderRoute: typeof AuthenticatedAssessmentsIndexLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_auth/sign-up/': {
      id: '/_auth/sign-up/'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof AuthSignUpIndexLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/reports/candidate-report/$rid': {
      id: '/reports/candidate-report/$rid'
      path: '/reports/candidate-report/$rid'
      fullPath: '/reports/candidate-report/$rid'
      preLoaderRoute: typeof ReportsCandidateReportRidLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/_route-wapper/success': {
      id: '/onboarding/_route-wapper/success'
      path: '/success'
      fullPath: '/onboarding/success'
      preLoaderRoute: typeof OnboardingRouteWapperSuccessLazyRouteImport
      parentRoute: typeof OnboardingRouteWapperRouteRoute
    }
    '/onboarding/_route-wapper/create-org': {
      id: '/onboarding/_route-wapper/create-org'
      path: '/create-org'
      fullPath: '/onboarding/create-org'
      preLoaderRoute: typeof OnboardingRouteWapperCreateOrgLazyRouteImport
      parentRoute: typeof OnboardingRouteWapperRouteRoute
    }
    '/_oauth-callbacks/callback/zoom-oauth': {
      id: '/_oauth-callbacks/callback/zoom-oauth'
      path: '/zoom-oauth'
      fullPath: '/callback/zoom-oauth'
      preLoaderRoute: typeof OauthCallbacksCallbackZoomOauthLazyRouteImport
      parentRoute: typeof OauthCallbacksCallbackRouteRoute
    }
    '/_oauth-callbacks/callback/microsoft-oauth': {
      id: '/_oauth-callbacks/callback/microsoft-oauth'
      path: '/microsoft-oauth'
      fullPath: '/callback/microsoft-oauth'
      preLoaderRoute: typeof OauthCallbacksCallbackMicrosoftOauthLazyRouteImport
      parentRoute: typeof OauthCallbacksCallbackRouteRoute
    }
    '/_oauth-callbacks/callback/google-oauth': {
      id: '/_oauth-callbacks/callback/google-oauth'
      path: '/google-oauth'
      fullPath: '/callback/google-oauth'
      preLoaderRoute: typeof OauthCallbacksCallbackGoogleOauthLazyRouteImport
      parentRoute: typeof OauthCallbacksCallbackRouteRoute
    }
    '/_authenticated/settings/pipelines': {
      id: '/_authenticated/settings/pipelines'
      path: '/pipelines'
      fullPath: '/settings/pipelines'
      preLoaderRoute: typeof AuthenticatedSettingsPipelinesLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/settings/communications': {
      id: '/_authenticated/settings/communications'
      path: '/communications'
      fullPath: '/settings/communications'
      preLoaderRoute: typeof AuthenticatedSettingsCommunicationsLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/settings/career-pages': {
      id: '/_authenticated/settings/career-pages'
      path: '/career-pages'
      fullPath: '/settings/career-pages'
      preLoaderRoute: typeof AuthenticatedSettingsCareerPagesLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/settings/billing': {
      id: '/_authenticated/settings/billing'
      path: '/billing'
      fullPath: '/settings/billing'
      preLoaderRoute: typeof AuthenticatedSettingsBillingLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/settings/activity-log': {
      id: '/_authenticated/settings/activity-log'
      path: '/activity-log'
      fullPath: '/settings/activity-log'
      preLoaderRoute: typeof AuthenticatedSettingsActivityLogLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/jobs/create': {
      id: '/_authenticated/jobs/create'
      path: '/jobs/create'
      fullPath: '/jobs/create'
      preLoaderRoute: typeof AuthenticatedJobsCreateLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/assessments/$assessmentId': {
      id: '/_authenticated/assessments/$assessmentId'
      path: '/assessments/$assessmentId'
      fullPath: '/assessments/$assessmentId'
      preLoaderRoute: typeof AuthenticatedAssessmentsAssessmentIdLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_auth/sign-up/email-sent': {
      id: '/_auth/sign-up/email-sent'
      path: '/sign-up/email-sent'
      fullPath: '/sign-up/email-sent'
      preLoaderRoute: typeof AuthSignUpEmailSentLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_authenticated/settings/manage-team': {
      id: '/_authenticated/settings/manage-team'
      path: '/manage-team'
      fullPath: '/settings/manage-team'
      preLoaderRoute: typeof AuthenticatedSettingsManageTeamRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_auth/auth/set-password': {
      id: '/_auth/auth/set-password'
      path: '/auth/set-password'
      fullPath: '/auth/set-password'
      preLoaderRoute: typeof AuthAuthSetPasswordRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_authenticated/jobs/$jobId': {
      id: '/_authenticated/jobs/$jobId'
      path: '/jobs/$jobId'
      fullPath: '/jobs/$jobId'
      preLoaderRoute: typeof AuthenticatedJobsJobIdRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_auth/auth/talent-scout': {
      id: '/_auth/auth/talent-scout'
      path: '/auth/talent-scout'
      fullPath: '/auth/talent-scout'
      preLoaderRoute: typeof AuthAuthTalentScoutRouteRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_authenticated/settings/operation-log/': {
      id: '/_authenticated/settings/operation-log/'
      path: '/operation-log'
      fullPath: '/settings/operation-log'
      preLoaderRoute: typeof AuthenticatedSettingsOperationLogIndexLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/onboarding/complete/': {
      id: '/_authenticated/onboarding/complete/'
      path: '/onboarding/complete'
      fullPath: '/onboarding/complete'
      preLoaderRoute: typeof AuthenticatedOnboardingCompleteIndexLazyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/jobs/$jobId/': {
      id: '/_authenticated/jobs/$jobId/'
      path: '/'
      fullPath: '/jobs/$jobId/'
      preLoaderRoute: typeof AuthenticatedJobsJobIdIndexLazyRouteImport
      parentRoute: typeof AuthenticatedJobsJobIdRouteRoute
    }
    '/_auth/auth/talent-scout/': {
      id: '/_auth/auth/talent-scout/'
      path: '/'
      fullPath: '/auth/talent-scout/'
      preLoaderRoute: typeof AuthAuthTalentScoutIndexLazyRouteImport
      parentRoute: typeof AuthAuthTalentScoutRouteRoute
    }
    '/_auth/auth/callback/': {
      id: '/_auth/auth/callback/'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthAuthCallbackIndexRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_authenticated/settings/operation-log/$operation_id': {
      id: '/_authenticated/settings/operation-log/$operation_id'
      path: '/operation-log/$operation_id'
      fullPath: '/settings/operation-log/$operation_id'
      preLoaderRoute: typeof AuthenticatedSettingsOperationLogOperation_idLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/settings/database/export': {
      id: '/_authenticated/settings/database/export'
      path: '/database/export'
      fullPath: '/settings/database/export'
      preLoaderRoute: typeof AuthenticatedSettingsDatabaseExportLazyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteLazyRoute
    }
    '/_authenticated/jobs/$jobId/source-candidates': {
      id: '/_authenticated/jobs/$jobId/source-candidates'
      path: '/source-candidates'
      fullPath: '/jobs/$jobId/source-candidates'
      preLoaderRoute: typeof AuthenticatedJobsJobIdSourceCandidatesLazyRouteImport
      parentRoute: typeof AuthenticatedJobsJobIdRouteRoute
    }
    '/_authenticated/jobs/$jobId/refine': {
      id: '/_authenticated/jobs/$jobId/refine'
      path: '/refine'
      fullPath: '/jobs/$jobId/refine'
      preLoaderRoute: typeof AuthenticatedJobsJobIdRefineLazyRouteImport
      parentRoute: typeof AuthenticatedJobsJobIdRouteRoute
    }
    '/_authenticated/jobs/$jobId/recommendations': {
      id: '/_authenticated/jobs/$jobId/recommendations'
      path: '/recommendations'
      fullPath: '/jobs/$jobId/recommendations'
      preLoaderRoute: typeof AuthenticatedJobsJobIdRecommendationsLazyRouteImport
      parentRoute: typeof AuthenticatedJobsJobIdRouteRoute
    }
    '/_authenticated/jobs/$jobId/client-submissions': {
      id: '/_authenticated/jobs/$jobId/client-submissions'
      path: '/client-submissions'
      fullPath: '/jobs/$jobId/client-submissions'
      preLoaderRoute: typeof AuthenticatedJobsJobIdClientSubmissionsLazyRouteImport
      parentRoute: typeof AuthenticatedJobsJobIdRouteRoute
    }
    '/_authenticated/jobs/$jobId/configure': {
      id: '/_authenticated/jobs/$jobId/configure'
      path: '/configure'
      fullPath: '/jobs/$jobId/configure'
      preLoaderRoute: typeof AuthenticatedJobsJobIdConfigureRouteRouteImport
      parentRoute: typeof AuthenticatedJobsJobIdRouteRoute
    }
    '/_authenticated/jobs/$jobId/assessments/': {
      id: '/_authenticated/jobs/$jobId/assessments/'
      path: '/assessments'
      fullPath: '/jobs/$jobId/assessments'
      preLoaderRoute: typeof AuthenticatedJobsJobIdAssessmentsIndexLazyRouteImport
      parentRoute: typeof AuthenticatedJobsJobIdRouteRoute
    }
    '/_authenticated/jobs/$jobId/configure/triggers': {
      id: '/_authenticated/jobs/$jobId/configure/triggers'
      path: '/triggers'
      fullPath: '/jobs/$jobId/configure/triggers'
      preLoaderRoute: typeof AuthenticatedJobsJobIdConfigureTriggersLazyRouteImport
      parentRoute: typeof AuthenticatedJobsJobIdConfigureRouteRoute
    }
    '/_authenticated/jobs/$jobId/configure/publish': {
      id: '/_authenticated/jobs/$jobId/configure/publish'
      path: '/publish'
      fullPath: '/jobs/$jobId/configure/publish'
      preLoaderRoute: typeof AuthenticatedJobsJobIdConfigurePublishLazyRouteImport
      parentRoute: typeof AuthenticatedJobsJobIdConfigureRouteRoute
    }
    '/_authenticated/jobs/$jobId/configure/export': {
      id: '/_authenticated/jobs/$jobId/configure/export'
      path: '/export'
      fullPath: '/jobs/$jobId/configure/export'
      preLoaderRoute: typeof AuthenticatedJobsJobIdConfigureExportLazyRouteImport
      parentRoute: typeof AuthenticatedJobsJobIdConfigureRouteRoute
    }
    '/_authenticated/jobs/$jobId/candidate/$id': {
      id: '/_authenticated/jobs/$jobId/candidate/$id'
      path: '/candidate/$id'
      fullPath: '/jobs/$jobId/candidate/$id'
      preLoaderRoute: typeof AuthenticatedJobsJobIdCandidateIdLazyRouteImport
      parentRoute: typeof AuthenticatedJobsJobIdRouteRoute
    }
  }
}

interface AuthAuthTalentScoutRouteRouteChildren {
  AuthAuthTalentScoutIndexLazyRoute: typeof AuthAuthTalentScoutIndexLazyRoute
}

const AuthAuthTalentScoutRouteRouteChildren: AuthAuthTalentScoutRouteRouteChildren =
  {
    AuthAuthTalentScoutIndexLazyRoute: AuthAuthTalentScoutIndexLazyRoute,
  }

const AuthAuthTalentScoutRouteRouteWithChildren =
  AuthAuthTalentScoutRouteRoute._addFileChildren(
    AuthAuthTalentScoutRouteRouteChildren,
  )

interface AuthRouteRouteChildren {
  AuthLoginRoute: typeof AuthLoginRoute
  AuthSignInRoute: typeof AuthSignInRoute
  AuthForgotPasswordLazyRoute: typeof AuthForgotPasswordLazyRoute
  AuthAuthTalentScoutRouteRoute: typeof AuthAuthTalentScoutRouteRouteWithChildren
  AuthAuthSetPasswordRoute: typeof AuthAuthSetPasswordRoute
  AuthSignUpEmailSentLazyRoute: typeof AuthSignUpEmailSentLazyRoute
  AuthSignUpIndexLazyRoute: typeof AuthSignUpIndexLazyRoute
  AuthAuthCallbackIndexRoute: typeof AuthAuthCallbackIndexRoute
}

const AuthRouteRouteChildren: AuthRouteRouteChildren = {
  AuthLoginRoute: AuthLoginRoute,
  AuthSignInRoute: AuthSignInRoute,
  AuthForgotPasswordLazyRoute: AuthForgotPasswordLazyRoute,
  AuthAuthTalentScoutRouteRoute: AuthAuthTalentScoutRouteRouteWithChildren,
  AuthAuthSetPasswordRoute: AuthAuthSetPasswordRoute,
  AuthSignUpEmailSentLazyRoute: AuthSignUpEmailSentLazyRoute,
  AuthSignUpIndexLazyRoute: AuthSignUpIndexLazyRoute,
  AuthAuthCallbackIndexRoute: AuthAuthCallbackIndexRoute,
}

const AuthRouteRouteWithChildren = AuthRouteRoute._addFileChildren(
  AuthRouteRouteChildren,
)

interface AuthenticatedSettingsRouteLazyRouteChildren {
  AuthenticatedSettingsManageTeamRoute: typeof AuthenticatedSettingsManageTeamRoute
  AuthenticatedSettingsActivityLogLazyRoute: typeof AuthenticatedSettingsActivityLogLazyRoute
  AuthenticatedSettingsBillingLazyRoute: typeof AuthenticatedSettingsBillingLazyRoute
  AuthenticatedSettingsCareerPagesLazyRoute: typeof AuthenticatedSettingsCareerPagesLazyRoute
  AuthenticatedSettingsCommunicationsLazyRoute: typeof AuthenticatedSettingsCommunicationsLazyRoute
  AuthenticatedSettingsPipelinesLazyRoute: typeof AuthenticatedSettingsPipelinesLazyRoute
  AuthenticatedSettingsIndexLazyRoute: typeof AuthenticatedSettingsIndexLazyRoute
  AuthenticatedSettingsDatabaseExportLazyRoute: typeof AuthenticatedSettingsDatabaseExportLazyRoute
  AuthenticatedSettingsOperationLogOperation_idLazyRoute: typeof AuthenticatedSettingsOperationLogOperation_idLazyRoute
  AuthenticatedSettingsOperationLogIndexLazyRoute: typeof AuthenticatedSettingsOperationLogIndexLazyRoute
}

const AuthenticatedSettingsRouteLazyRouteChildren: AuthenticatedSettingsRouteLazyRouteChildren =
  {
    AuthenticatedSettingsManageTeamRoute: AuthenticatedSettingsManageTeamRoute,
    AuthenticatedSettingsActivityLogLazyRoute:
      AuthenticatedSettingsActivityLogLazyRoute,
    AuthenticatedSettingsBillingLazyRoute:
      AuthenticatedSettingsBillingLazyRoute,
    AuthenticatedSettingsCareerPagesLazyRoute:
      AuthenticatedSettingsCareerPagesLazyRoute,
    AuthenticatedSettingsCommunicationsLazyRoute:
      AuthenticatedSettingsCommunicationsLazyRoute,
    AuthenticatedSettingsPipelinesLazyRoute:
      AuthenticatedSettingsPipelinesLazyRoute,
    AuthenticatedSettingsIndexLazyRoute: AuthenticatedSettingsIndexLazyRoute,
    AuthenticatedSettingsDatabaseExportLazyRoute:
      AuthenticatedSettingsDatabaseExportLazyRoute,
    AuthenticatedSettingsOperationLogOperation_idLazyRoute:
      AuthenticatedSettingsOperationLogOperation_idLazyRoute,
    AuthenticatedSettingsOperationLogIndexLazyRoute:
      AuthenticatedSettingsOperationLogIndexLazyRoute,
  }

const AuthenticatedSettingsRouteLazyRouteWithChildren =
  AuthenticatedSettingsRouteLazyRoute._addFileChildren(
    AuthenticatedSettingsRouteLazyRouteChildren,
  )

interface AuthenticatedJobsJobIdConfigureRouteRouteChildren {
  AuthenticatedJobsJobIdConfigureExportLazyRoute: typeof AuthenticatedJobsJobIdConfigureExportLazyRoute
  AuthenticatedJobsJobIdConfigurePublishLazyRoute: typeof AuthenticatedJobsJobIdConfigurePublishLazyRoute
  AuthenticatedJobsJobIdConfigureTriggersLazyRoute: typeof AuthenticatedJobsJobIdConfigureTriggersLazyRoute
}

const AuthenticatedJobsJobIdConfigureRouteRouteChildren: AuthenticatedJobsJobIdConfigureRouteRouteChildren =
  {
    AuthenticatedJobsJobIdConfigureExportLazyRoute:
      AuthenticatedJobsJobIdConfigureExportLazyRoute,
    AuthenticatedJobsJobIdConfigurePublishLazyRoute:
      AuthenticatedJobsJobIdConfigurePublishLazyRoute,
    AuthenticatedJobsJobIdConfigureTriggersLazyRoute:
      AuthenticatedJobsJobIdConfigureTriggersLazyRoute,
  }

const AuthenticatedJobsJobIdConfigureRouteRouteWithChildren =
  AuthenticatedJobsJobIdConfigureRouteRoute._addFileChildren(
    AuthenticatedJobsJobIdConfigureRouteRouteChildren,
  )

interface AuthenticatedJobsJobIdRouteRouteChildren {
  AuthenticatedJobsJobIdConfigureRouteRoute: typeof AuthenticatedJobsJobIdConfigureRouteRouteWithChildren
  AuthenticatedJobsJobIdClientSubmissionsLazyRoute: typeof AuthenticatedJobsJobIdClientSubmissionsLazyRoute
  AuthenticatedJobsJobIdRecommendationsLazyRoute: typeof AuthenticatedJobsJobIdRecommendationsLazyRoute
  AuthenticatedJobsJobIdRefineLazyRoute: typeof AuthenticatedJobsJobIdRefineLazyRoute
  AuthenticatedJobsJobIdSourceCandidatesLazyRoute: typeof AuthenticatedJobsJobIdSourceCandidatesLazyRoute
  AuthenticatedJobsJobIdIndexLazyRoute: typeof AuthenticatedJobsJobIdIndexLazyRoute
  AuthenticatedJobsJobIdCandidateIdLazyRoute: typeof AuthenticatedJobsJobIdCandidateIdLazyRoute
  AuthenticatedJobsJobIdAssessmentsIndexLazyRoute: typeof AuthenticatedJobsJobIdAssessmentsIndexLazyRoute
}

const AuthenticatedJobsJobIdRouteRouteChildren: AuthenticatedJobsJobIdRouteRouteChildren =
  {
    AuthenticatedJobsJobIdConfigureRouteRoute:
      AuthenticatedJobsJobIdConfigureRouteRouteWithChildren,
    AuthenticatedJobsJobIdClientSubmissionsLazyRoute:
      AuthenticatedJobsJobIdClientSubmissionsLazyRoute,
    AuthenticatedJobsJobIdRecommendationsLazyRoute:
      AuthenticatedJobsJobIdRecommendationsLazyRoute,
    AuthenticatedJobsJobIdRefineLazyRoute:
      AuthenticatedJobsJobIdRefineLazyRoute,
    AuthenticatedJobsJobIdSourceCandidatesLazyRoute:
      AuthenticatedJobsJobIdSourceCandidatesLazyRoute,
    AuthenticatedJobsJobIdIndexLazyRoute: AuthenticatedJobsJobIdIndexLazyRoute,
    AuthenticatedJobsJobIdCandidateIdLazyRoute:
      AuthenticatedJobsJobIdCandidateIdLazyRoute,
    AuthenticatedJobsJobIdAssessmentsIndexLazyRoute:
      AuthenticatedJobsJobIdAssessmentsIndexLazyRoute,
  }

const AuthenticatedJobsJobIdRouteRouteWithChildren =
  AuthenticatedJobsJobIdRouteRoute._addFileChildren(
    AuthenticatedJobsJobIdRouteRouteChildren,
  )

interface AuthenticatedRouteRouteChildren {
  AuthenticatedSettingsRouteLazyRoute: typeof AuthenticatedSettingsRouteLazyRouteWithChildren
  AuthenticatedApplicationsLazyRoute: typeof AuthenticatedApplicationsLazyRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedJobsJobIdRouteRoute: typeof AuthenticatedJobsJobIdRouteRouteWithChildren
  AuthenticatedAssessmentsAssessmentIdLazyRoute: typeof AuthenticatedAssessmentsAssessmentIdLazyRoute
  AuthenticatedJobsCreateLazyRoute: typeof AuthenticatedJobsCreateLazyRoute
  AuthenticatedAssessmentsIndexLazyRoute: typeof AuthenticatedAssessmentsIndexLazyRoute
  AuthenticatedAtsCheckerIndexLazyRoute: typeof AuthenticatedAtsCheckerIndexLazyRoute
  AuthenticatedDiscussionsIndexLazyRoute: typeof AuthenticatedDiscussionsIndexLazyRoute
  AuthenticatedHelpCenterIndexLazyRoute: typeof AuthenticatedHelpCenterIndexLazyRoute
  AuthenticatedInterviewsIndexLazyRoute: typeof AuthenticatedInterviewsIndexLazyRoute
  AuthenticatedJobsIndexLazyRoute: typeof AuthenticatedJobsIndexLazyRoute
  AuthenticatedLeaderboardsIndexLazyRoute: typeof AuthenticatedLeaderboardsIndexLazyRoute
  AuthenticatedLearningHubIndexLazyRoute: typeof AuthenticatedLearningHubIndexLazyRoute
  AuthenticatedPracticeIndexLazyRoute: typeof AuthenticatedPracticeIndexLazyRoute
  AuthenticatedProfileIndexLazyRoute: typeof AuthenticatedProfileIndexLazyRoute
  AuthenticatedResumeBuilderIndexLazyRoute: typeof AuthenticatedResumeBuilderIndexLazyRoute
  AuthenticatedRoadmapsIndexLazyRoute: typeof AuthenticatedRoadmapsIndexLazyRoute
  AuthenticatedSalaryInsightsIndexLazyRoute: typeof AuthenticatedSalaryInsightsIndexLazyRoute
  AuthenticatedSupportIndexLazyRoute: typeof AuthenticatedSupportIndexLazyRoute
  AuthenticatedOnboardingCompleteIndexLazyRoute: typeof AuthenticatedOnboardingCompleteIndexLazyRoute
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedSettingsRouteLazyRoute:
    AuthenticatedSettingsRouteLazyRouteWithChildren,
  AuthenticatedApplicationsLazyRoute: AuthenticatedApplicationsLazyRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedJobsJobIdRouteRoute:
    AuthenticatedJobsJobIdRouteRouteWithChildren,
  AuthenticatedAssessmentsAssessmentIdLazyRoute:
    AuthenticatedAssessmentsAssessmentIdLazyRoute,
  AuthenticatedJobsCreateLazyRoute: AuthenticatedJobsCreateLazyRoute,
  AuthenticatedAssessmentsIndexLazyRoute:
    AuthenticatedAssessmentsIndexLazyRoute,
  AuthenticatedAtsCheckerIndexLazyRoute: AuthenticatedAtsCheckerIndexLazyRoute,
  AuthenticatedDiscussionsIndexLazyRoute:
    AuthenticatedDiscussionsIndexLazyRoute,
  AuthenticatedHelpCenterIndexLazyRoute: AuthenticatedHelpCenterIndexLazyRoute,
  AuthenticatedInterviewsIndexLazyRoute: AuthenticatedInterviewsIndexLazyRoute,
  AuthenticatedJobsIndexLazyRoute: AuthenticatedJobsIndexLazyRoute,
  AuthenticatedLeaderboardsIndexLazyRoute:
    AuthenticatedLeaderboardsIndexLazyRoute,
  AuthenticatedLearningHubIndexLazyRoute:
    AuthenticatedLearningHubIndexLazyRoute,
  AuthenticatedPracticeIndexLazyRoute: AuthenticatedPracticeIndexLazyRoute,
  AuthenticatedProfileIndexLazyRoute: AuthenticatedProfileIndexLazyRoute,
  AuthenticatedResumeBuilderIndexLazyRoute:
    AuthenticatedResumeBuilderIndexLazyRoute,
  AuthenticatedRoadmapsIndexLazyRoute: AuthenticatedRoadmapsIndexLazyRoute,
  AuthenticatedSalaryInsightsIndexLazyRoute:
    AuthenticatedSalaryInsightsIndexLazyRoute,
  AuthenticatedSupportIndexLazyRoute: AuthenticatedSupportIndexLazyRoute,
  AuthenticatedOnboardingCompleteIndexLazyRoute:
    AuthenticatedOnboardingCompleteIndexLazyRoute,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

interface OnboardingRouteWapperRouteRouteChildren {
  OnboardingRouteWapperCreateOrgLazyRoute: typeof OnboardingRouteWapperCreateOrgLazyRoute
  OnboardingRouteWapperSuccessLazyRoute: typeof OnboardingRouteWapperSuccessLazyRoute
}

const OnboardingRouteWapperRouteRouteChildren: OnboardingRouteWapperRouteRouteChildren =
  {
    OnboardingRouteWapperCreateOrgLazyRoute:
      OnboardingRouteWapperCreateOrgLazyRoute,
    OnboardingRouteWapperSuccessLazyRoute:
      OnboardingRouteWapperSuccessLazyRoute,
  }

const OnboardingRouteWapperRouteRouteWithChildren =
  OnboardingRouteWapperRouteRoute._addFileChildren(
    OnboardingRouteWapperRouteRouteChildren,
  )

interface OnboardingProfileRouteRouteChildren {
  OnboardingProfileIndexLazyRoute: typeof OnboardingProfileIndexLazyRoute
}

const OnboardingProfileRouteRouteChildren: OnboardingProfileRouteRouteChildren =
  {
    OnboardingProfileIndexLazyRoute: OnboardingProfileIndexLazyRoute,
  }

const OnboardingProfileRouteRouteWithChildren =
  OnboardingProfileRouteRoute._addFileChildren(
    OnboardingProfileRouteRouteChildren,
  )

interface OnboardingRouteRouteChildren {
  OnboardingRouteWapperRouteRoute: typeof OnboardingRouteWapperRouteRouteWithChildren
  OnboardingProfileRouteRoute: typeof OnboardingProfileRouteRouteWithChildren
}

const OnboardingRouteRouteChildren: OnboardingRouteRouteChildren = {
  OnboardingRouteWapperRouteRoute: OnboardingRouteWapperRouteRouteWithChildren,
  OnboardingProfileRouteRoute: OnboardingProfileRouteRouteWithChildren,
}

const OnboardingRouteRouteWithChildren = OnboardingRouteRoute._addFileChildren(
  OnboardingRouteRouteChildren,
)

interface OneauthRouteRouteChildren {
  OneauthTokenLazyRoute: typeof OneauthTokenLazyRoute
  OneauthConnectLazyRoute: typeof OneauthConnectLazyRoute
}

const OneauthRouteRouteChildren: OneauthRouteRouteChildren = {
  OneauthTokenLazyRoute: OneauthTokenLazyRoute,
  OneauthConnectLazyRoute: OneauthConnectLazyRoute,
}

const OneauthRouteRouteWithChildren = OneauthRouteRoute._addFileChildren(
  OneauthRouteRouteChildren,
)

interface OrganizationsRouteRouteChildren {
  OrganizationsIndexLazyRoute: typeof OrganizationsIndexLazyRoute
}

const OrganizationsRouteRouteChildren: OrganizationsRouteRouteChildren = {
  OrganizationsIndexLazyRoute: OrganizationsIndexLazyRoute,
}

const OrganizationsRouteRouteWithChildren =
  OrganizationsRouteRoute._addFileChildren(OrganizationsRouteRouteChildren)

interface OauthCallbacksCallbackRouteRouteChildren {
  OauthCallbacksCallbackGoogleOauthLazyRoute: typeof OauthCallbacksCallbackGoogleOauthLazyRoute
  OauthCallbacksCallbackMicrosoftOauthLazyRoute: typeof OauthCallbacksCallbackMicrosoftOauthLazyRoute
  OauthCallbacksCallbackZoomOauthLazyRoute: typeof OauthCallbacksCallbackZoomOauthLazyRoute
}

const OauthCallbacksCallbackRouteRouteChildren: OauthCallbacksCallbackRouteRouteChildren =
  {
    OauthCallbacksCallbackGoogleOauthLazyRoute:
      OauthCallbacksCallbackGoogleOauthLazyRoute,
    OauthCallbacksCallbackMicrosoftOauthLazyRoute:
      OauthCallbacksCallbackMicrosoftOauthLazyRoute,
    OauthCallbacksCallbackZoomOauthLazyRoute:
      OauthCallbacksCallbackZoomOauthLazyRoute,
  }

const OauthCallbacksCallbackRouteRouteWithChildren =
  OauthCallbacksCallbackRouteRoute._addFileChildren(
    OauthCallbacksCallbackRouteRouteChildren,
  )

const rootRouteChildren: RootRouteChildren = {
  AuthRouteRoute: AuthRouteRouteWithChildren,
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  OnboardingRouteRoute: OnboardingRouteRouteWithChildren,
  OneauthRouteRoute: OneauthRouteRouteWithChildren,
  OrganizationsRouteRoute: OrganizationsRouteRouteWithChildren,
  AcceptInviteRoute: AcceptInviteRoute,
  OauthCallbacksCallbackRouteRoute:
    OauthCallbacksCallbackRouteRouteWithChildren,
  PortfolioUserIdRoute: PortfolioUserIdRoute,
  ScheduleTokenRoute: ScheduleTokenRoute,
  errors401LazyRoute: errors401LazyRoute,
  errors403LazyRoute: errors403LazyRoute,
  errors404LazyRoute: errors404LazyRoute,
  errors500LazyRoute: errors500LazyRoute,
  errors503LazyRoute: errors503LazyRoute,
  OrgNotFoundLazyRoute: OrgNotFoundLazyRoute,
  ReportsCandidateReportRidLazyRoute: ReportsCandidateReportRidLazyRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
